export const SystemManager_API = {
  calendar: {
    getCalendar,
    getCalendarByOrganizationId,
    getCalendarByVerifyId,
    addCalendarItem,
    updateCalendarItem,
    deleteCalendarItem
  },
  allPatients: { getPatient, updatePatient, getPatientQuiz, updatePatientQuiz, getListOfStudyTypes },
  activities: {
    mistakes: {
      getMistakes
    },
    assistants: {
      getAssistants,
      getAssistant,
      updateAssistant,
      deleteAssistant,
      addAssistant
    }
  },
  errors: {
    carSurvey: {
      getAllCarSurveys,
      getOrganizationCarSurveys,
      carSurveyRegistryGeneration,
      carSurveyPdfGeneration,
      updateSurveyPatient,
	  getAllCarSurveysToday,
	  setCarSurveyToday
    },
    cabinetSurvey: {
      getAllCabinetSurveys,
      getAllOrganizationCabinetSurveys,
      cabinetSurveyPdfGeneration,
      cabinetSurveyRegistryGeneration,
      updateSurveyPatient
    }
  },
  counterAgents: {
    verificationCenter: {
      getAllOrganizationsByVerifyId,
      changePayedStatus,
      uploadListsVerCenter,
      pdfGenerationVerCenter,
      addNewStudyVerCenter,
	  getVerCenterPrices,
	  saveVerCenterPrices,
	  getVerCenterDoctorPrices,
	  saveVerCenterDoctorPrices,
	  getMachines,
	  saveMachine,
	  addPayment,
	  getPaymentsOfOrg,
    },
    medCenter: {},
    organization: {
      paymentUpdate,
      uploadLists,
      getOrganizationsHistory,
      pdfGenerationOrganization,
      addNewStudyOrganization
    },
    all: {}
  },
  doctors: {getDoctors, getTestResults, getApproves, approve, getErrors,saveDoctor}
}
//mistakes
function getMistakes() {
  return {api: '/api/v1/systemManager/mistakes?', method: 'GET'}
}

function addPayment(userId) {
  return {api: `/api/v2/systemManagers/${userId}/addPayment`, method: 'POST'}
}
function getPaymentsOfOrg(userId, companyId) {
  return {api: `/api/v2/systemManagers/${userId}/getPaymentsOfOrg/${companyId}`, method: 'GET'}
}

//doctors

function getDoctors(userId) {
  return {api: `/api/v2/systemManagers/${userId}/doctors?`, method: 'GET'}
}
function saveDoctor(userId,id) {
  return {api: `/api/v2/systemManagers/${userId}/doctors/${id}/save`, method: 'POST'}
}
function getTestResults(userId) {
  return {api: `/api/v2/systemManagers/${userId}/doctors/tests?`, method: 'GET'}
}
function getApproves(userId) {
  return {api: `/api/v2/systemManagers/${userId}/studies?`, method: 'GET'}
}

function approve(userId,id) {
  return {api: `/api/v2/systemManagers/${userId}/studies/${id}/status`, method: 'PUT'}
}

function getErrors(userId) {
  return {api: `/api/v2/systemManagers/${userId}/studies/mismatch?`, method: 'GET'}
}

//allPatients
function getPatient(userId,patientId, resultId) {
  return { api: `/api/v2/systemManagers/${userId}/patients/${patientId}/results/${resultId}`, method: 'GET' }
}

function updatePatient(userId,patientId, resultId) {
  return { api: `/api/v2/systemManagers/${userId}/patients/${patientId}/results/${resultId}`, method: 'PUT' }
}


//Activities
//roles
function getAssistants(userId) {
  return { api: `/api/v2/systemManagers/${userId}/employees?`, method: 'GET' }
}

function getAssistant(userId,assistantId) {
  return { api: `/api/v2/systemManagers/${userId}/employees/${assistantId}`, method: 'GET' }
}

function addAssistant(userId) {
  return { api: `/api/v2/systemManagers/${userId}/employees`, method: 'POST' }
}

function updateAssistant(userId,assistantId) {
  return { api: `/api/v2/systemManagers/${userId}/employees/${assistantId}`, method: 'PUT' }
}

function deleteAssistant(userId,assistantId) {
  return { api: `/api/v2/systemManagers/${userId}/employees/${assistantId}`, method: 'DELETE' }
}

//Errors
function updateSurveyPatient(userId, orgId, errorId) {
  return { api: `/api/v1/systemManager/errors/${orgId}/patients/${errorId}`, method: 'PUT' }
}

//Errors/carSurvey

function getAllCarSurveys(userId) {
  return { api: `/api/v2/systemManagers/${userId}/histories?`, method: 'GET' }
}

function getOrganizationCarSurveys(userid, orgId) {
  return { api: `/api/v2/systemManagers/${userid}/histories/${orgId}?`, method: 'GET' }
}

function carSurveyPdfGeneration(orgId) {
  return { api: `/api/v1/systemManager/errors/${orgId}/results?`, method: 'GET' }
}

function carSurveyRegistryGeneration(orgId) {
  return { api: `/api/v1/systemManager/errors/${orgId}/results/registry?`, method: 'GET' }
}

//Errors/cabinetSurvey
function getAllCabinetSurveys(userId) {
  return { api: `/api/v2/systemManagers/${userId}/cabhistories?`, method: 'GET' }
}

function getAllOrganizationCabinetSurveys(orgId) {
  return { api: `/api/v1/systemManager/study/organizations/${orgId}?`, method: 'GET' }
}

function cabinetSurveyPdfGeneration(orgId) {
  return { api: `/api/v1/systemManager/study/organizations/${orgId}/results?`, method: 'GET' }
}

function cabinetSurveyRegistryGeneration(orgId) {
  return { api: `/api/v1/systemManager/study/organizations/${orgId}/results/registry?`, method: 'GET' }
}

function getPatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/systemManagers/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'GET' }
}

function updatePatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/systemManagers/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'PUT' }
}

function getListOfStudyTypes() {
  return { api: `/api/v1/doctors/listOfTypes`, method: 'POST' }
}

//verificationCenter

function getAllOrganizationsByVerifyId(verifyId) {
  return { api: `/api/v2/verificationCenters/${verifyId}/counterparties?`, method: 'GET' }
}

function changePayedStatus(userId,verCenterId, medId, orgId, historyId) {
  return {
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations/${orgId}/histories/${historyId}/payed`,
    method: 'PUT'
  }
}

function uploadListsVerCenter(userId,verCenterId, medId, orgId, historyId) {
  return {
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations/${orgId}/histories/${historyId}`
  }
}

function pdfGenerationVerCenter(historyId) {
  return {
    api: `/api/v2/general/export/pdf/${historyId}`,
    method: 'GET'
  }
}

function addNewStudyVerCenter(userId, verCenterId, medId, orgId) {
  return { api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations/${orgId}/histories` }
}


//organization
function addNewStudyOrganization(userId,verCenterId, orgId) {
  return { api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/organizations/${orgId}/histories`, method: 'POST' }
}

function paymentUpdate(userId,verifyId, orgId, historyId) {
  return {
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verifyId}/organizations/${orgId}/histories/${historyId}/payed`,
    method: 'PUT'
  }
}

function pdfGenerationOrganization(historyId) {
  return {
    api: `/api/v2/general/export/pdf/${historyId}`,
    method: 'GET'
  }
}

function uploadLists(userId,verifyId, orgId, historyId) {
  return {
    api: `/api/v2/systemManagers/${userId}/verificationCenters/${verifyId}/organizations/${orgId}/histories/${historyId}`,
    method: 'POST'
  }
}

function getOrganizationsHistory(userId,verCenterId,orgId) {
  return { api: `/api/v2/systemManagers/${userId}/verificationCenters/${verCenterId}/organizations/${orgId}/histories?`, method: 'GET' }
}


//Calendar

function getCalendar(amoId) {
  return { api: `/api/v1/systemManager/calendars`, method: 'GET' }
}

function getCalendarByOrganizationId(orgId) {
  return { api: `/api/v1/systemManager/calendars/organizations/${orgId}`, method: 'GET' }
}

function getCalendarByVerifyId(verifyId) {
  return { api: `/api/v1/systemManager/calendars/verificationCenters/${verifyId}`, method: 'GET' }
}

function addCalendarItem() {
  return { api: `/api/v1/systemManager/calendars/`, method: 'POST' }
}

function updateCalendarItem(updatedCalendarItemId) {
  return { api: `/api/v1/systemManager/calendars/${updatedCalendarItemId}`, method: 'PUT' }
}

function deleteCalendarItem(deletedItemId) {
  return { api: `/api/v1/systemManager/calendars/${deletedItemId}`, method: 'DELETE' }
}

function getAllCarSurveysToday(userId) {
  return { api: `/api/v2/systemManagers/${userId}/historiestoday?`, method: 'GET' }
}
function setCarSurveyToday(userId, studyId, actionId) {
  return { api: `/api/v2/systemManagers/${userId}/historiessettoday/${studyId}/${actionId}`, method: 'POST' }
}


function getVerCenterPrices(userId, verCenterId) {
  return { api: `/api/v2/systemManagers/${userId}/getVerCenterPrices/${verCenterId}`, method: 'GET' }
}
function saveVerCenterPrices(userId, verCenterId) {
  return { api: `/api/v2/systemManagers/${userId}/saveVerCenterPrices/${verCenterId}`, method: 'POST' }
}
function getVerCenterDoctorPrices(userId, verCenterId, doctorId) {
  return { api: `/api/v2/systemManagers/${userId}/getVerCenterDoctorPrices/${verCenterId}/${doctorId}`, method: 'GET' }
}
function saveVerCenterDoctorPrices(userId, verCenterId, doctorId) {
  return { api: `/api/v2/systemManagers/${userId}/saveVerCenterPrices/${verCenterId}/${doctorId}`, method: 'POST' }
}
function getMachines(userId, verCenterId) {
  return { api: `/api/v2/systemManagers/${userId}/getVerCenterMachines/${verCenterId}`, method: 'GET' }
}
function saveMachine(userId, verCenterId, machineId) {
  return { api: `/api/v2/systemManagers/${userId}/saveMachine/${verCenterId}/${machineId}`, method: 'POST' }
}

